import { SurveyQuestion } from '../../models/survey/question';
import { SurveyAnswer } from '../../models/survey/answer';

export const SurveyAction = {
    SetData: 'SET_DATA',
    SetAnswers: 'SET_ANSWERS',
};

export interface SurveySetData {
    type: typeof SurveyAction.SetData,
    value: { questions: SurveyQuestion[], answers: { [key: number]: SurveyAnswer } },
}

export interface SurveySetAnswers {
    type: typeof SurveyAction.SetAnswers,
    value: { answers: { [key: number]: SurveyAnswer } },
}

export type SurveyActions =
    SurveySetData |
    SurveySetAnswers;
